export const StubProjectsPageTexts = {
  thisPage: 'Esta página',
  will: 'estará',
  be: 'lista',
  readySoon: 'en breve',
};
